import { render, staticRenderFns } from "./LoaderBar.vue?vue&type=template&id=7c70c5be&scoped=true&"
import script from "./LoaderBar.vue?vue&type=script&lang=js&"
export * from "./LoaderBar.vue?vue&type=script&lang=js&"
import style0 from "./LoaderBar.vue?vue&type=style&index=0&id=7c70c5be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70c5be",
  null
  
)

export default component.exports